/**
 * Constants and data mappings
 */

/**
 * List of US state abbreviations
 */
export const usStates = [
    'AL',
    'AK',
    'AS',
    'AZ',
    'AR',
    'CA',
    'CO',
    'CT',
    'DE',
    'DC',
    'FM',
    'FL',
    'GA',
    'GU',
    'HI',
    'ID',
    'IL',
    'IN',
    'IA',
    'KS',
    'KY',
    'LA',
    'ME',
    'MH',
    'MD',
    'MA',
    'MI',
    'MN',
    'MS',
    'MO',
    'MT',
    'NE',
    'NV',
    'NH',
    'NJ',
    'NM',
    'NY',
    'NC',
    'ND',
    'MP',
    'OH',
    'OK',
    'OR',
    'PW',
    'PA',
    'PR',
    'RI',
    'SC',
    'SD',
    'TN',
    'TX',
    'UT',
    'VT',
    'VI',
    'VA',
    'WA',
    'WV',
    'WI',
    'WY',
];

export const incomeTypes = {
    JobIncome: 'Job Income',
    SelfEmployed: 'Self Employed',
    Benefits: 'Benefits',
    Pension: 'Pension',
    SocialSecurity: 'Social Security',
    Disability: 'Disability',
    Military: 'Military',
    Student: 'Student',
    Other: 'Other',
};

/**
 * Converts a provider ID to its display name
 * @param providerId The provider ID (string or number)
 */
export const providerIdToName = (providerId: string | number) => {
    const providerIdNumber = Number(providerId);

    if (!isNaN(providerIdNumber)) {
        switch (Number(providerId)) {
            case 1:
                return 'GreenSky';
            case 2:
                return 'ServiceFinance';
            case 3:
                return 'Turns';
            case 4:
                return 'Financeit';
            case 5:
                return 'GoodLeap';
            case 6:
                return 'WellsFargo';
            case 7:
                return 'Synchrony';
            case 8:
                return 'BuyFin';
            default:
                return 'None';
        }
    }
    switch (providerId?.toString().toLowerCase()) {
        case 'greensky':
            return 'GreenSky';
        case 'servicefinance':
            return 'Service Finance';
        case 'turns':
            return 'Turns';
        case 'financeit':
            return 'Financeit';
        case 'goodleap':
            return 'GoodLeap';
        case 'wellsfargo':
            return 'Wells Fargo';
        case 'synchrony':
            return 'Synchrony';
        case 'buyfin':
            return 'BuyFin';
        default:
            return 'None';
    }
};
